import React from 'react';
import { CheckCircle2Icon, CreditCardIcon, FileDownIcon, ShieldCheckIcon } from 'lucide-react';
import { heroHighlights, productImages } from '../../data/kit';
import { offer } from '../../data/offer';
import { CtaButton } from '../ui/CtaButton';
export function HeroSection() {
  return <section id="top" className="bg-cream pb-10 pt-8 sm:pb-14 sm:pt-14 lg:pb-20 lg:pt-16" data-id="element-68" data-mp="1x9ajqwx3pplc">
      <div className="mx-auto grid max-w-[1180px] gap-x-12 gap-y-7 px-5 sm:px-8 lg:grid-cols-[1.05fr_.95fr] lg:items-center lg:gap-y-6" data-id="element-69" data-mp="1s9ehp37ys88f">
        <div className="text-center lg:col-start-1 lg:row-start-1 lg:self-end lg:text-left" data-id="element-70" data-mp="1ni67i4yt8iu7">
          <span className="inline-flex items-center gap-2 rounded-full border border-petrol/30 px-4 py-2 text-[10px] font-bold uppercase tracking-[.16em] text-petrol sm:text-[11px]" data-id="element-71" data-mp="1ikwgwlzoq14s">
            <span aria-hidden="true" className="h-1.5 w-1.5 rounded-full bg-petrol" data-id="element-72" data-mp="19jgaepbzqj5u" />
            For speech &amp; language professionals
          </span>
          <h1 className="mx-auto mt-5 max-w-[340px] font-display text-[42px] font-extrabold uppercase leading-[.92] tracking-[-.01em] text-petrol sm:mt-6 sm:max-w-none sm:text-[64px] lg:text-[76px]" data-id="element-73" data-mp="14m6kl8kow5hh">
            Your next speech session, <span className="text-coral" data-id="element-74" data-mp="2snprganf90uc">already on paper.</span>
          </h1>
        </div>

        <div className="flex justify-center lg:col-start-2 lg:row-span-2 lg:row-start-1" data-id="element-75" data-mp="2wort0y4t9ozh">
          <img src={productImages.boxSet} alt="Speech Therapy Ready Fall Sessions Starter Kit: box set with the main kit and 5 bonuses, 40 printable pages" width={1024} height={1536} className="h-auto w-full max-w-[280px] rounded-3xl shadow-lift sm:max-w-[380px] lg:max-w-[440px]" data-id="element-76" data-mp="3kem3xa5kl3h3" />
        </div>

        <div className="text-center lg:col-start-1 lg:row-start-2 lg:self-start lg:text-left" data-id="element-77" data-mp="3gb7bfk0g2umr">
          <p className="hidden max-w-[560px] text-lg leading-relaxed text-slate lg:block" data-id="element-78" data-mp="1zx7gyokdbx6w">
            Speech Therapy Ready is a 40-page printable kit with three complete fall units — session routes, read-aloud
            stories, picture and prompt cards, data sheets and home practice. Choose the goal, print, and start.
          </p>
          <ul className="mt-5 hidden flex-wrap gap-x-5 gap-y-2 lg:flex" data-id="element-79" data-mp="rtxkhj61ke6">
            {heroHighlights.map(item => <li key={item} className="flex items-center gap-1.5 text-[15px] font-bold text-petrol" data-id="element-80" data-mp="3sw5v2qocn2yu">
                <CheckCircle2Icon className="h-4 w-4 text-teal" aria-hidden="true" data-id="element-81" data-mp="3nwtbqfwose10" />
                {item}
              </li>)}
          </ul>
          <div className="lg:mt-7" data-id="element-82" data-mp="3izjfohesl447">
            <CtaButton href="#offer-details" className="w-full max-w-[420px] sm:w-auto" data-id="element-83" data-mp="3dxu2av43kecy">
              Get the starter kit
            </CtaButton>
          </div>
          <ul className="mx-auto mt-5 flex max-w-[340px] flex-wrap justify-center gap-x-5 gap-y-2 text-sm text-slate sm:max-w-none lg:justify-start" data-id="element-84" data-mp="39yuwl8ajkdkg">
            <li className="flex items-center gap-1.5" data-id="element-85" data-mp="186gkipuoi3by">
              <FileDownIcon className="h-4 w-4 text-petrol" aria-hidden="true" data-id="element-86" data-mp="183ko55yhbmpm" />
              PDF download
            </li>
            <li className="flex items-center gap-1.5" data-id="element-87" data-mp="2v1lfi10sy69b">
              <CreditCardIcon className="h-4 w-4 text-petrol" aria-hidden="true" data-id="element-88" data-mp="2v0aa5wrpkqg3" />
              Pay in local currency
            </li>
            <li className="flex items-center gap-1.5" data-id="element-89" data-mp="33u6vxagyo0uz">
              <ShieldCheckIcon className="h-4 w-4 text-petrol" aria-hidden="true" data-id="element-90" data-mp="33tnd7rjhl8fw" />
              {offer.guaranteeDays}-day guarantee
            </li>
          </ul>
        </div>
      </div>
    </section>;
}